import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import { useSession } from "../auth/SessionProvider";
import Login from "../auth/Login";
import AppLayout from "./AppLayout";
import FinancePage from "../modules/finanzas/FinancePage";
import BankReport from "../modules/finanzas/BankReport";
import Cobros from "../modules/cobros/Cobros";
import InicioPage from "../modules/inicio/InicioPage";
import CRMPage from "../modules/crm/CRMPage";
import VentasPage from "../modules/ventas/VentasPage";
import CatalogPage from "../modules/catalogos/CatalogPage";
import ReportPage, {
  ReportPicker,
  reportCatalog,
} from "../modules/reportes/ReportPage";
import { Status } from "../shared/UI";
function Gate({ children, kind, permission }) {
  const params = useParams(),
    location = useLocation(),
    { session } = useSession();
  const p =
    permission ||
    (kind === "reportes"
      ? reportCatalog[params.kind]?.permission
      : params.kind);
  return session.modules[p] ? (
    React.cloneElement(children, { key: location.pathname })
  ) : (
    <Alert variant="warning">No tienes acceso a esta sección.</Alert>
  );
}
export default function AppRoutes() {
  const { session, loading, error, reload, logout } = useSession();
  if (loading)
    return (
      <div className="boot">
        <Status loading />
      </div>
    );
  if (!session) {
    if (localStorage.getItem("authToken") && error)
      return (
        <div className="boot">
          <Alert variant="danger">
            {error}
            <div>
              <Button onClick={reload}>Reintentar</Button>
              <Button variant="link" onClick={logout}>
                Volver al inicio de sesión
              </Button>
            </div>
          </Alert>
        </div>
      );
    return <Login />;
  }
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<InicioPage />} />
        <Route
          path="crm/:kind"
          element={
            <Gate>
              <CRMPage />
            </Gate>
          }
        />
        <Route
          path="ventas/:kind"
          element={
            <Gate>
              <VentasPage />
            </Gate>
          }
        />
        <Route
          path="catalogos/:kind"
          element={
            <Gate>
              <CatalogPage />
            </Gate>
          }
        />
        <Route path="finanzas/:kind" element={<Gate><FinancePage /></Gate>} />
        <Route path="cobranza/cobros" element={<Gate permission="cobros"><Cobros /></Gate>} />
        <Route
          path="cobranza"
          element={
            <Gate permission="cartera">
              <ReportPage mode="cartera" />
            </Gate>
          }
        />
        <Route
          path="estado-cuenta"
          element={
            <Gate permission="cartera">
              <ReportPage mode="estado-cuenta" />
            </Gate>
          }
        />
        <Route path="reportes" element={<ReportPicker />} />
        <Route
          path="reportes/bancos"
          element={
            <Gate permission="bancos">
              <BankReport />
            </Gate>
          }
        />
        <Route
          path="reportes/:kind"
          element={
            <Gate kind="reportes">
              <ReportPage />
            </Gate>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
